<template>
  <div class="oai-StepHeader">
    <p v-if="stepLabel" class="oai-StepHeader_Label">
      {{ stepLabel }}
    </p>

    <slot name="title">
      <i18n-t
        v-if="titleKeyPath"
        :keypath="titleKeyPath"
        scope="global"
        tag="h1"
        class="oai-StepHeader_Title"
      >
        <template #[titleKeyName]>
          <span class="oai-StepHeader_TitleAccent">{{ titleKeyAccent }}</span>
        </template>
      </i18n-t>
    </slot>

    <p v-if="subtitle" class="oai-StepHeader_Subtitle">
      {{ subtitle }}
    </p>

    <slot name="after-subtitle" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { useOnboardingAiWizardStepCount } from '@/composables/onboarding-ai-step'

defineOptions({
  name: 'OnboardingAiStepHeader'
})

const props = defineProps({
  wizardStep: {
    type: Number,
    required: true
  },

  titleKeyPath: {
    type: String,
    required: true
  },

  titleKeyName: {
    type: String,
    required: true
  },

  titleKeyAccent: {
    type: String,
    required: true
  },

  subtitle: {
    type: String,
    default: ''
  }
})

const { t } = useI18n()
const totalWizardStepCount = useOnboardingAiWizardStepCount()

const stepLabel = computed(() =>
  t('onboarding.ai.wizard_step_of', {
    current: props.wizardStep,
    total: totalWizardStepCount
  })
)
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/onboarding-ai-step';

.oai-StepHeader {
  display: grid;
  gap: 12px;
  width: 100%;
}

.oai-StepHeader_Label {
  margin: 0;
  font-size: $fs-12;
  line-height: 18px;
  font-weight: fw('semi-bold');
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: $oai-text-muted;
}

.oai-StepHeader_Subtitle {
  margin: 0;
  font-size: $fs-14;
  line-height: 20px;
  font-weight: fw('regular');
  color: $oai-text-muted;
}
</style>
